
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premier-agent/[[...slug]]",
      function () {
        return require("private-next-pages/premier-agent/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premier-agent/[[...slug]]"])
      });
    }
  